import { Tooltip } from 'antd'

import { CategoryTitleCell } from 'components/FieldRenderers/CategoryTitleCell'
import ProductCatalogTitleCell from 'components/FieldRenderers/ProductCatalogTitleCell/ProductCatalogTitleCell'
import { Field } from 'types'

import { createField } from './createField'
import { FieldCreatorOptions } from './localTypes'

export function orgPerformanceProductSmallImageUrl<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return createField({
        ...options,
        id: 'product_small_image_url',
        name: 'Product Image URL',
        shortName: 'Product Image URL',
        dataIndex: options.dataIndex ?? ['product_small_image_url'],
        isVisible: false,
    })
}

export function orgPerformanceProductId<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return createField({
        ...options,
        id: 'product_id',
        name: 'Product ID',
        shortName: 'Product ID',
        dataIndex: options.dataIndex ?? ['product_id'],
        isVisible: false,
    })
}

export function orgPerformanceLeafCategoryId<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return createField({
        ...options,
        id: 'leaf_category_id',
        name: 'Category ID',
        shortName: 'Category ID',
        dataIndex: options.dataIndex ?? ['leaf_category_id'],
        isVisible: false,
    })
}

export function orgPerformanceLeafCategoryName<RecordType>(
    options: FieldCreatorOptions<RecordType> & {
        dateRange?: string[]
    } = {}
): Field<RecordType> {
    return createField({
        ...options,
        id: 'leaf_category_name',
        name: 'Category',
        shortName: 'Category',
        dataIndex: options.dataIndex ?? ['leaf_category_name'],
        minWidth: 150,
        width: 250,
        renderOptions: {
            render: ({ value, record }: any) => (
                <CategoryTitleCell
                    value={value}
                    categoryId={record.leaf_category_id}
                    marketplace={record.marketplace}
                    dateRange={options.dateRange}
                />
            ),
        },
    })
}

export function orgPerformanceMarketplace<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return createField({
        ...options,
        id: 'marketplace',
        name: 'Marketplace',
        shortName: 'Marketplace',
        dataIndex: options.dataIndex ?? ['marketplace'],
        width: 130,
    })
}

export function orgPerformanceProductTitle<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return createField({
        ...options,
        id: 'product_title',
        name: 'Product',
        shortName: 'Product',
        minWidth: 200,
        dataIndex: options.dataIndex ?? ['product_title'],
        width: 300,
        renderOptions: {
            render: ({ value, record }: any) => {
                const productAsin = record.product_id?.split('_')[1]
                return (
                    <ProductCatalogTitleCell
                        value={value}
                        productImg={record.product_small_image_url}
                        size="small"
                        linkToProductDetails
                        productMarketplace={record.marketplace}
                        productAsin={productAsin}
                        titleFormatter={(val) => (
                            <Tooltip title={val}>{val}</Tooltip>
                        )}
                    />
                )
            },
        },
    })
}
